<template>
  <Layout v-loading="pageLoading">
    <title-repeat-check ref="titleCheck"></title-repeat-check>
    <div class="row box_wrap" style="height: calc(100vh - 175px)">
      <div class="col-lg-12">
        <div class="">
          <div class="card-body">
            <div class="card-body-form">
              <div v-if="allModify" class="page-transparent-bg"></div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>标题</label>
                    <div class="title-limit-desc">
                      <input
                        :disabled="isModify"
                        v-model="item.title"
                        type="text"
                        class="form-control"
                        maxlength="200"
                        placeholder="请输入1-200个字"
                        @blur="checkTitle(item.title)"
                      />
                      <span class="number-of-word"
                        >{{ item.title.length }}/200</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>短标题</label>
                    <div class="title-limit-desc">
                      <input
                        :disabled="isModify"
                        v-model="item.subTitle"
                        type="text"
                        class="form-control"
                        maxlength="200"
                        placeholder="请输入1-200个字"
                      />
                      <span class="number-of-word"
                        >{{ item.subTitle.length }}/200</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>描述</label>
                    <input
                      :disabled="isModify"
                      v-model="item.content"
                      type="text"
                      class="form-control"
                      maxlength="100"
                      placeholder="请输入1-100个字"
                    />
                  </div>
                </div>
              </div> -->
              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>来源</label>
                    <input
                      :disabled="isModify"
                      v-model="item.source"
                      type="text"
                      class="form-control"
                      placeholder="如果有来源输入来源"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>显示状态</label>
                    <div>
                      <el-radio
                        class="mg-b-no"
                        v-model="item.showState"
                        :label="1"
                        >显示</el-radio
                      >
                      <el-radio
                        class="mg-b-no"
                        v-model="item.showState"
                        :label="0"
                        >隐藏</el-radio
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label>发布日期</label><br />
                    <el-date-picker
                      v-model="item.publishedAt"
                      type="datetime"
                      placeholder="选择日期时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>设置</label>
                    <div class="dsply-fix">
                      <b-form-checkbox
                        class="m-r-30"
                        v-for="item in operable"
                        :key="item.key"
                        v-model="choiceOperable"
                        :value="item.key"
                        checked
                        plain
                        >{{ item.text }}</b-form-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>评论限制</label>
                    <div class="dsply-fix">
                      <b-form-checkbox
                        class="m-r-30"
                        v-for="item in commentRests"
                        :key="item.key"
                        v-model="choiceCommentRests"
                        :value="item.key"
                        checked
                        plain
                        >{{ item.text }}</b-form-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>标签</label>
                    <div
                      class="select-tabs flex"
                      style="align-items: center; flex-wrap: wrap"
                    >
                      <div
                        v-for="item in currentTabs"
                        :key="item.id"
                        role="alert"
                        aria-live="polite"
                        aria-atomic="true"
                        class="pull-left alert alert-primary m-r-20"
                      >
                        {{ item.name }}
                        <span @click="removeTabs(item)">
                          <i class="bx bx-x font-size-16 align-middle"></i>
                        </span>
                      </div>

                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="selectTag()"
                      >
                        <i
                          class="bx bx-plus font-size-16 align-middle me-2"
                        ></i>
                        添加
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>运营</label>
                    <div class="dsply-fix">
                      <!--                      <b-form-checkbox
                      class="m-r-30"
                      v-for="item in operateSet" :key="item.key"
                      v-model="choiceOperateSet"
                      :value="item.key"
                      checked
                      plain
                      >{{ item.text }}</b-form-checkbox>-->
                      <div class="operate-input-item">
                        <span class="pull-left">阅读数</span>
                        <input
                          v-model="item.operateViewNum"
                          type="text"
                          class="form-control"
                          placeholder="数字"
                        />
                      </div>
                      <div class="operate-input-item">
                        <span class="pull-left">点赞数</span>
                        <input
                          v-model="item.operateLikeNum"
                          type="text"
                          class="form-control"
                          placeholder="数字"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7">
                  <div class="mb-3">
                    <label>分享标题</label>
                    <div class="title-limit-desc">
                      <input
                        v-model="item.shareTitle"
                        type="text"
                        class="form-control"
                        maxlength="200"
                        placeholder="请输入1-200个字"
                      />
                      <span class="number-of-word"
                        >{{ item.shareTitle.length }}/200</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>分享图片</label>
                    <div class="mb-3">
                      <upload-button
                        type="image"
                        @onSuccess="shareImageSuccess"
                        :mustEdit="true"
                      ></upload-button>
                    </div>
                    <div
                      class="cover-images clearfix"
                      style="margin-top: 10px; margin-bottom: 10px"
                    >
                      <div class="cover-img-item m-r-40" v-if="shareImage">
                        <div class="cover-image-main">
                          <image-upload
                            :fixedWidth="150"
                            size="1:1"
                            v-model="shareImage.url"
                            @uploadChange="changeShareImage"
                            type="image"
                            :isShowDel="false"
                          ></image-upload>
                        </div>
                        <span class="cover-delete" @click="removeShareImage()"
                          >删除</span
                        >
                      </div>
                    </div>
                    <div style="color: #aaa">
                      图片比例 1:1，建议尺寸 670 * 670
                      px，不上传则默认使用封面图片
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <label>角标</label>
                    <input
                      v-model="item.subscript"
                      maxlength="4"
                      type="text"
                      class="form-control"
                      placeholder="请输入1-4个字"
                    />
                  </div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-10">
                  <div class="mb-3">
                    <label>评论</label>
                    <div class="mb-3">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary m-r-20"
                        @click="selectComment(item)"
                      >
                        <i
                          class="bx bx-plus font-size-14 align-middle me-2"
                        ></i>
                        添加
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="removeComment()"
                        v-if="currentComments.length"
                      >
                        <i
                          class="bx bx-trash font-size-14 align-middle me-2"
                        ></i>
                        移除
                      </button>
                    </div>
                    <div
                      class="table-responsive-main-list"
                      v-if="currentComments.length"
                    >
                      <div class="table-responsive">
                        <table
                          class="table align-middle table-nowrap table-hover"
                        >
                          <thead class="table-light">
                            <tr>
                              <th scope="col" style="width: 70px"></th>
                              <th scope="col" style="width: 70px">ID</th>
                              <th scope="col">评论内容</th>
                              <th scope="col">评论附件</th>
                              <th scope="col">评论来源</th>
                              <th scope="col">来源标题</th>
                              <th scope="col">来源链接</th>
                              <th scope="col">点赞数</th>
                              <th scope="col">标签</th>
                              <th scope="col">采集时间</th>
                              <th scope="col">发布时间</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="data in currentComments" :key="data.id">
                              <td>
                                <b-form-checkbox
                                  v-model="selectCurrentItems"
                                  :value="data"
                                  checked
                                  plain
                                ></b-form-checkbox>
                              </td>
                              <td>{{ data.id }}</td>
                              <td class="white-inherit">{{ data.message }}</td>
                              <td>
                                <img
                                  v-if="data.image"
                                  class="w-3-rem"
                                  :src="`${data.image}`"
                                  alt
                                />
                                <img
                                  v-if="!data.image"
                                  class="w-3-rem"
                                  src="../../../assets/images/default_cover_1_1.png"
                                  alt=""
                                />
                              </td>
                              <td>{{ data.source }}</td>
                              <td>{{ data.title }}</td>
                              <td>{{ data.link }}</td>
                              <td>{{ data.likeNum || "--" }}</td>
                              <td>{{ data.tag || "--" }}</td>
                              <td>{{ data.collectedAt || "--" }}</td>
                              <td>{{ data.publishedAt || "--" }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>奖励</label>
                    <div>
                      <el-radio
                        :disabled="item.disabledType"
                        v-model="item.rewardType"
                        label="0"
                        >优惠券</el-radio
                      >
                      <el-radio
                        :disabled="item.disabledType"
                        v-model="item.rewardType"
                        label="1"
                        >红包</el-radio
                      >
                    </div>
                    <div v-if="item.rewardType == 0">
                      <div style="margin-top: 5px;">
                        <button
                          type="button"
                          class="btn btn-primary m-r-20"
                          @click="selectCoupon()"
                        >
                          <i
                            class="bx bx-plus font-size-16 align-middle me-2"
                          ></i>
                          添加
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteCoupon()"
                          v-if="currentArticle.id"
                        >
                          <i
                            class="bx bx-trash font-size-16 align-middle me-2"
                          ></i>
                          移除
                        </button>
                      </div>
                      <div
                        style="margin-top: 15px;"
                        class="table-responsive-main-list"
                        v-if="currentArticle.id"
                      >
                        <div class="table-responsive">
                          <table
                            class="table align-middle table-nowrap table-hover"
                          >
                            <thead class="table-light">
                              <tr>
                                <th scope="col" style="width: 70px;">ID</th>
                                <th scope="col">名称</th>
                                <th scope="col">类型</th>
                                <th scope="col">总库存</th>
                                <th scope="col">可用库存</th>
                                <th scope="col">发放量</th>
                                <th scope="col">核销量</th>
                                <th scope="col">所属商家</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ currentArticle.id }}</td>
                                <td class="w-200px white-inherit">
                                  {{ currentArticle.title }}
                                </td>
                                <td>
                                  <template
                                    v-if="currentArticle.couponType == 1"
                                    >代金券</template
                                  >
                                  <template
                                    v-if="currentArticle.couponType == 2"
                                    >折扣券</template
                                  >
                                  <template
                                    v-if="currentArticle.couponType == 3"
                                    >通用券</template
                                  >
                                </td>
                                <td>
                                  {{ currentArticle.countNumber || "--" }}
                                </td>
                                <td>{{ currentArticle.quantity || "--" }}</td>
                                <td>{{ currentArticle.grantNumber || "0" }}</td>
                                <td>
                                  {{ currentArticle.verifyNumber || "0" }}
                                </td>
                                <td>
                                  {{ currentArticle.merchant_name || "--" }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div v-if="item.rewardType == 1">
                      <div class="dsply-fix">
                        <div style="padding-top: 10px;">
                          <el-radio
                            :disabled="item.disabledType"
                            v-model="item.redPacket.type"
                            label="0"
                            >平分</el-radio
                          >
                          <el-radio
                            :disabled="item.disabledType"
                            v-model="item.redPacket.type"
                            label="1"
                            >拼手气</el-radio
                          >
                        </div>
                        <div class="dsply-fix" style="margin-left: 15px">
                          <span style="padding-top: 10px;">份数：</span>
                          <input
                            style="width: 100px;"
                            v-model="item.redPacket.total"
                            :disabled="item.disabledType"
                            type="text"
                            class="form-control"
                            placeholder="整数"
                          />
                        </div>
                        <div class="dsply-fix" style="margin-left: 15px">
                          <span style="padding-top: 10px;">红包点数：</span>
                          <input
                            style="width: 100px;"
                            :disabled="item.disabledType"
                            v-model="item.redPacket.totalAmount"
                            type="text"
                            class="form-control"
                            placeholder="0.00"
                          />
                        </div>
                        <div style="padding-top: 10px;margin-left: 15px">
                          可用点数：{{ pointTotal }}，每份红包不得小于0.3
                        </div>
                      </div>
                      <div class="dsply-fix" style="margin-top: 10px;">
                        <span style="padding-top: 10px;margin-right: 10px"
                          >观看视频</span
                        >
                        <input
                          style="width: 100px;"
                          :disabled="item.disabledType"
                          v-model="item.redPacket.time"
                          type="text"
                          class="form-control"
                          placeholder="5"
                        />
                        <span style="padding-top: 10px;margin-left: 10px"
                          >秒后可以领取红包</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>门店</label>
                    <div>
                      <div style="margin-top: 5px;">
                        <button
                          type="button"
                          class="btn btn-primary m-r-20"
                          @click="selectShop()"
                        >
                          <i
                            class="bx bx-plus font-size-16 align-middle me-2"
                          ></i>
                          添加
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteShop()"
                          v-if="currentShop.id"
                        >
                          <i
                            class="bx bx-trash font-size-16 align-middle me-2"
                          ></i>
                          移除
                        </button>
                      </div>
                      <div
                        style="margin-top: 15px;"
                        class="table-responsive-main-list"
                        v-if="currentShop.id"
                      >
                        <div class="table-responsive">
                          <table
                            class="table align-middle table-nowrap table-hover"
                          >
                            <thead class="table-light">
                              <tr>
                                <th scope="col" style="width: 70px;">ID</th>
                                <th scope="col">门店名称</th>
                                <th scope="col">门店地址</th>
                                <th scope="col">创建时间</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ currentShop.id }}</td>
                                <td>{{ currentShop.name }}</td>
                                <td>{{ currentShop.address || "--" }}</td>
                                <td>{{ currentShop.createdAt || "--" }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="row app-disabled-main">
                <div v-if="isModify" class="disabled-main-bg"></div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>封面图片</label>
                    <div class="mb-3">
                      <div class="pull-left">
                        <button
                          :disabled="
                            isModify || showGetCover() || getCoverLoading
                          "
                          @click="getCovers()"
                          type="button"
                          class="btn btn-sm btn-primary m-r-10"
                          :loading="getCoverLoading"
                        >
                          <i
                            v-if="!getCoverLoading"
                            class="bx el-icon-download font-size-14 me-2 align-middle"
                          ></i>
                          <i
                            v-else
                            class="bx el-icon-loading font-size-14 me-2 align-middle"
                          ></i>
                          获取智能封面
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-primary"
                          @click="videoCut()"
                          :disabled="!item.videoUrl || coverCutLoading"
                        >
                          <i
                            v-if="coverCutLoading"
                            class="bx el-icon-loading font-size-14 me-2 align-middle"
                          ></i
                          >截取封面
                        </button>
                      </div>
                      <upload-button
                        style="margin-left: 10px"
                        type="image"
                        :disabled="isModify"
                        @onSuccess="uploadSuccess"
                        :mustEdit="true"
                      ></upload-button>
                      <div style="color: #aaa; margin-top: 5px">
                        图片比例 16:9，建议尺寸 1500 * 840 px，建议文件小于10MB
                      </div>
                    </div>
                    <div class="cover-images clearfix">
                      <div
                        class="cover-img-item m-r-40"
                        v-for="(url, index) in coverImags"
                        v-bind:key="index"
                      >
                        <div class="cover-image-main">
                          <!-- <img :src="url" alt="" /> -->
                          <image-upload
                            :fixedWidth="200"
                            size="16:9"
                            v-model="coverImags[index]"
                            :disabled="isModify"
                            @uploadChange="changeCover"
                          ></image-upload>
                          <i
                            v-if="item.image != url"
                            @click="item.image = url"
                            class="bx bx-circle"
                          ></i>
                          <i
                            v-if="item.image == url"
                            class="bx bx-check-circle"
                          ></i>
                        </div>
                        <span class="cover-delete" @click="removeCover(index)"
                          >删除</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="index_id">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>首帧图</label>
                    <div class="mb-3">
                      <button
                        @click="getFirstSnap()"
                        type="primary"
                        class="btn btn-sm btn-primary m-r-20"
                        style="margin-right: 10px"
                        :disabled="firstSnapLoading"
                      >
                        <i
                          v-if="firstSnapLoading"
                          class="bx el-icon-loading font-size-14 me-2 align-middle"
                        ></i
                        >截取首帧图
                      </button>
                    </div>
                    <image-upload
                      v-if="item.firstSnap"
                      :fixedWidth="200"
                      size="16:9"
                      v-model="item.firstSnap"
                      :disabled="true"
                      type="image"
                      :isShowDel="false"
                    ></image-upload>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label>视频详情</label>
                    <div class="mb-3 flex" v-if="isChangeVideo">
                      <upload-button
                        type="video"
                        :text="item.videoUrl ? '更换视频' : '上传视频'"
                        :disabled="isModify"
                        @onSuccess="uploadVideoSuccess"
                        @statusChange="uploadChange"
                      >
                        <div
                          slot="uploadWarning"
                          style="
                              color: red;
                              font-size: 12px;
                              margin-top: 10px;
                            "
                        >
                          本地上传仅支持mp4格式，其他视频格式需从媒资库引入
                        </div>
                      </upload-button>
                      <!-- <button
                          style="margin-left:10px;"
                          @click="videoCut()"
                          class="btn-sm btn btn-primary"
                          type="button"
                      >
                        截取封面
                      </button> -->

                      <button
                        v-if="index_id"
                        @click="videoTranscoding()"
                        type="button"
                        class="btn btn-sm btn-primary"
                        style="margin-left: 10px"
                      >
                        视频转码
                      </button>
                      <!-- <button
                        type="button"
                        class="btn btn-primary"
                        @click="choseFile"
                      >
                        <i
                          class="bx bx-upload font-size-16 align-middle me-2"
                        ></i>
                        {{ item.videoUrl ? "更换视频" : "上传视频" }}
                      </button>
                      <show-progress
                        v-if="videoLoading"
                        dataName="videoUpload"
                        style="width: 106px; margin-top: 5px"
                      ></show-progress> -->
                    </div>
                    <input
                      type="file"
                      style="display: none"
                      id="upload_file"
                      ref="upload_file"
                      @change="upload"
                    />
                    <div class="flex mb-3">
                      <div
                        class="video-url-bg video_wrap  m-r-10"
                        :style="{
                          width: allModify ? '300px' : '500px',
                        }"
                        v-if="item.videoUrl"
                      >
                        <template v-if="!allModify">
                          <iframe-player
                            v-if="checkM3u8(item.videoUrl)"
                            :autoplay="false"
                            width="100%"
                            height="100%"
                            ref="iframePlayer"
                            :src="item.videoUrl"
                          ></iframe-player>
                          <video
                            v-else
                            id="video"
                            useCORS="true"
                            crossOrigin="Anonymous"
                            controls="controls"
                            :src="item.videoUrl"
                          ></video>
                        </template>
                        <view-video
                          v-if="allModify"
                          :disabled="true"
                          :src="item.videoUrl"
                        ></view-video>
                        <el-button
                          class="liveCilStyle"
                          size="mini"
                          type="text"
                          icon="el-icon-film"
                          >原始视频 {{ showVideoExt(item.videoUrl) }}
                          <div style="font-size:10px">
                            {{ videoUrlSize }}
                          </div></el-button
                        >
                      </div>
                      <div
                        class="video-url-bg video_wrap"
                        v-if="item.transcodeUrl"
                        :style="{
                          width: allModify ? '300px' : '500px',
                        }"
                      >
                        <template v-if="!allModify">
                          <iframe-player
                            v-if="checkM3u8(item.transcodeUrl)"
                            :autoplay="false"
                            width="100%"
                            height="100%"
                            ref="iframePlayer"
                            :src="item.transcodeUrl"
                          ></iframe-player>
                          <video
                            v-else
                            id="video"
                            useCORS="true"
                            crossOrigin="Anonymous"
                            controls="controls"
                            :src="item.transcodeUrl"
                          ></video>
                        </template>

                        <view-video
                          v-if="allModify"
                          :disabled="true"
                          :src="item.transcodeUrl"
                        ></view-video>

                        <el-button
                          class="liveCilStyle"
                          size="mini"
                          type="text"
                          icon="el-icon-film"
                          >转码视频 {{ showVideoExt(item.transcodeUrl) }}
                          <div style="font-size:10px">
                            {{ transcodeUrlSize }}
                          </div></el-button
                        >
                      </div>
                    </div>
                    <div v-if="index_id" style="color:red">
                      *转码视频是基于上传的原始视频进行标准化转码处理后的视频，有转码时客户端展示转码视频，没有则展示原始视频。更新替换原始视频会同步修改转码视频。对于未转码的视频可以进行手动转码
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <comment-dialog
        @pageCallback="pageCallback"
        ref="comment"
      ></comment-dialog> -->
      <!-- 操作日志 -->
      <operationLog :show.sync="show" :resId="resId"></operationLog>
      <tag-dialog @pageCallback="pageCallback" ref="tag"></tag-dialog>
      <coupon-dialog @pageCallback="pageCallback" ref="coupon"></coupon-dialog>
      <examine-dialog
        ref="examine"
        @pageCallback="pageCallback"
      ></examine-dialog>
      <shop-dialog ref="shop" @pageCallback="pageCallback"></shop-dialog>
      <!-- <comment-dialog @pageCallback="pageCallback" ref="comment"></comment-dialog> -->
      <!-- <gather-dialog @pageCallback="pageCallback" ref="gather"></gather-dialog> -->
      <!-- <chen-video-dialog @pageCallback="pageCallback" ref="chenvideo"></chen-video-dialog> -->
    </div>
    <!-- <div style="height: 6px; border-bottom: 1px solid #ced4da"></div> -->
    <div
      class="row submit-bar"
      style="
        margin-bottom: 0;
        margin-top: 0;
        padding-top: 0;
        padding-bottom: 0;
        height: 45px;
        display: flex;
        align-items: center;
      "
    >
      <div class="col-md-12">
        <div class="last-time pull-left">
          <button
            style="margin-left: 20px"
            @click="openLog"
            class="btn-sm btn btn-warning"
            type="button"
          >
            操作日志
          </button>
        </div>
        <!-- <div class="last-time pull-left">由 用户名 编辑于 2021-09-12 12:11:22</div> -->
        <div class="bar-handle" v-if="!allModify">
          <button
            class="btn-sm btn btn-outline-dark"
            type="button"
            @click="goBack()"
          >
            返回
          </button>
          <span>
            <button
              v-if="index_id"
              @click="toPreview()"
              class="btn-sm btn btn-primary"
              type="button"
            >
              预览
            </button>
          </span>
          <div v-if="index_id">
            <button
              v-if="!isModify && power['提交审核/撤销审核/驳回原因']"
              @click="submitReview()"
              class="btn-sm btn btn-warning"
              type="button"
            >
              {{ verifyFlag == 1 ? "保存并免审发布" : "保存并提交审核" }}
            </button>
            <button
              @click="submitPreserve()"
              v-if="!isModify"
              class="btn-sm btn btn-primary"
              type="button"
            >
              保存
            </button>
            <button
              @click="submitPreserve()"
              v-if="isModify"
              class="btn-sm btn btn-primary"
              type="button"
            >
              保存
            </button>
          </div>
          <div v-if="!index_id">
            <button
              @click="submitReview()"
              class="btn-sm btn btn-warning"
              type="button"
              v-if="power['提交审核/撤销审核/驳回原因']"
            >
              {{ verifyFlag == 1 ? "创建并免审发布" : "创建并提交审核" }}
            </button>
            <button
              @click="submitPreserve()"
              class="btn-sm btn btn-primary"
              type="button"
            >
              创建
            </button>
          </div>
        </div>
        <div class="bar-handle" v-if="allModify">
          <button
            v-if="item.verifyState == 3 && power['提交审核/撤销审核/驳回原因']"
            @click="batchRevert()"
            class="btn-sm btn btn-warning"
            type="button"
          >
            撤销审核
          </button>
          <button
            class="btn-sm btn btn-outline-dark"
            type="button"
            @click="goBack()"
          >
            返回
          </button>
        </div>
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      size="450px"
      :direction="direction"
      :show-close="false"
    >
      <iframe ref="iframe" class="iframe-item" :src="previewUrl"></iframe>
    </el-drawer>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import tagDialog from "@/components/choseTag/tagDialog.vue";
import couponDialog from "./couponDialog";
import shopDialog from "./shopDialog";
import examineDialog from "./examineDialog";
import content from "../../../server/api/videoPublish";
import tags from "../../../server/api/tags";
import auth from "../../../server/api/auth";
import coupon from "../../../server/api/coupons";
import shop from "../../../server/api/shop";
import operationLog from "@/components/operationLog.vue";
import { uploadFile } from "@/server/api/cos";
import showProgress from "@/components/uploadProgress/showProgress.vue";
// import commentDialog from "@/router/views/articlePublish/commentDialog";
import imageUpload from "@/components/imageUpload";
import { getVideoDuration, waitTime, checkImageLink } from "@/util/fun.js";
import videoCut from "@/util/videoCut";
import contentAPI from "@/server/api/content.js";
import { getOperateNum, checkRepeatTitle, getFileName } from "@/util/fun.js";
import TitleRepeatCheck from "@/components/TitleRepeatCheck.vue";
import util from "@/util/util";
import IframePlayer from "@/components/iframePlayer/IframePlayer.vue";

export default {
  components: {
    operationLog,
    Layout,
    DatePicker,
    tagDialog,
    examineDialog,
    couponDialog,
    shopDialog,
    showProgress,
    // commentDialog,
    imageUpload,
    TitleRepeatCheck,
    IframePlayer,
  },
  inject: ["reload"],
  data() {
    return {
      videoLoading: false,
      upload_file: "",
      operable: [
        { text: "关闭阅读数", key: "viewDisabled" },
        { text: "关闭评论", key: "commentDisabled" },
        { text: "关闭分享", key: "shareDisabled" },
        { text: "关闭点赞", key: "likeDisabled" },
      ],
      choiceOperable: [], //设置选择了那些
      commentRests: [
        { text: "关闭图片评论", key: "commentImageDisabled" },
        { text: "关闭视频评论", key: "commentVideoDisabled" },
      ],
      choiceCommentRests: [], //评论设置选择了那些
      item: {
        publishedAt: "",
        image: "",
        content: "",
        title: "",
        subTitle: "",
        videoUrl: "",
        redPacket: { time: "5" },
        showState: 1,
        shareTitle: "",
        transcodeUrl: "",
      },
      currentTabs: [],
      // currentComments: [],
      selectCurrentItems: [],
      coverImags: [],
      index_id: "",
      isModify: false,
      allModify: false,
      currentArticle: {},
      disabledDate: null,
      currentShop: {},
      isChangeVideo: true,
      pointTotal: 0,
      show: false,
      resId: undefined,
      getCoverLoading: false,
      verifyFlag: "",
      previewUrl: "",
      drawer: false,
      direction: "rtl",
      uploadStatus: true,
      shareImage: null,
      oldImage: null, //初始化页面最初封面图片
      oldImageWidth: 0, //初始化页面最初封面图片宽
      oldImageHeight: 0, //初始化页面最初封面图片高
      power: [],
      videoUrlSize: "",
      transcodeUrlSize: "",
      pageLoading: false,
      firstSnapLoading: false,
      coverCutLoading: false,
    };
  },
  created() {
    this.item.publishedAt = this.utils.getTodayTime();
    this.power = this.utils.currentPower("创作平台-视频发布");
  },
  mounted() {
    let data = JSON.parse(localStorage.chosedMedia);
    this.item.userId = data.id;
    this.verifyFlag = data.verifyFlag;

    //媒资库跳转创建视频
    this.item.videoUrl = this.$route.query.video
      ? decodeURI(this.$route.query.video)
      : "";
    this.item.title = this.item.subTitle = this.$route.query.title
      ? this.$route.query.title
      : "";
    if (this.$route.query.cover) {
      let cover = decodeURI(this.$route.query.cover);
      this.item.image = cover;
      this.item.firstSnap = cover;
      this.coverImags = [];
      this.coverImags.push(cover);
    }
    //转码地址
    if (this.$route.query.transcodeUrl) {
      this.item.transcodeUrl = decodeURI(this.$route.query.transcodeUrl);
      this.fromMediaLibrary = true;
      this.transcodeUrlSize = util.getFileSize(this.$route.query.transcodeSize);
      this.videoUrlSize = util.getFileSize(this.$route.query.size);
    }
    //任务id
    if (this.$route.query.taskId) {
      this.item.taskId = this.$route.query.taskId;
    }
    if (this.item.videoUrl) {
      this.getVideoTime(this.item.transcodeUrl || this.item.videoUrl);
    }

    // 获取详情
    if (this.$route.query.id) {
      this.index_id = Number(this.$route.query.id);
      this.checkLock();
      this.fetch();
    }
    if (this.$route.query.isModify) {
      this.isModify = true;
      this.isChangeVideo = false;
    }
    if (this.$route.query.allModify) {
      this.allModify = true;
      this.isChangeVideo = false;
    }
    this.disabledDate = this.utils.rangeDate();
    this.getRedPacketInfo();
  },

  methods: {
    checkM3u8(str) {
      if (str.indexOf(".m3u8") !== -1) {
        return true;
      }
    },
    getFirstSnap() {
      this.videoCut("first");
    },
    videoTranscoding() {
      contentAPI.videoTranscode({ url: this.item.videoUrl }).then((res) => {
        if (res.code == 0) {
          Swal.fire({
            title: `转码中……请稍后刷新页面查看`,
            icon: "success",
            showCloseButton: false,
            showConfirmButton: false,
            timer: 1000,
          });
        } else {
          Vue.swal(res.msg);
        }
      });
    },
    removeShareImage() {
      this.shareImage = null;
    },
    changeShareImage(url) {
      this.shareImage.url = url;
    },
    shareImageSuccess(file) {
      if (file.data) {
        this.shareImage = {
          url: file.data,
          type: file.type,
        };
      }
    },
    checkLock() {
      contentAPI
        .lock({
          id: this.index_id,
          isLock: 1,
        })
        .then((resp) => {
          // 有其他锁，弹窗
          if (resp.data) {
            Swal.fire({
              icon: "warning",
              html:
                "<h4>当前内容已被" +
                resp.data +
                "锁定，解锁编辑存在覆盖风险！</h4>",
              showCancelButton: true,
              allowEnterKey: false,
              allowOutsideClick: false,
              confirmButtonColor: "#ff0000",
              cancelButtonColor: "#74788d",
              confirmButtonText: "解锁",
              cancelButtonText: "取消",
              customClass: {
                confirmButton: "unlock-confirm-button",
              },
              width: "600px",
            }).then((result) => {
              this.removeAutoSave();
              if (result.isConfirmed) {
                contentAPI
                  .lock({
                    id: this.index_id,
                    isLock: 0,
                  })
                  .then((res) => {
                    contentAPI
                      .lock({
                        id: this.index_id,
                        isLock: 1,
                      })
                      .then((res) => {});
                  });
              } else if (result.isDismissed) {
                this.$router.go(-1);
              }
            });
          }
        });
    },
    videoCut(type) {
      if (!this.item.videoUrl) {
        return;
      }
      if (type == "first") {
        this.firstSnapLoading = true;
      } else {
        this.coverCutLoading = true;
      }
      const domId = "video";
      const targetSaturation = 0;
      videoCut
        .getBestPoster(domId, targetSaturation)
        .then((posterUrl) => {
          // const image = new Image()
          // image.src = posterUrl
          // document.body.append(image)
          // return;
          if (!posterUrl) {
            this.warning("截取失败");
            if (type == "first") {
              this.firstSnapLoading = false;
            } else {
              this.coverCutLoading = false;
            }
            return;
          }
          let dataurl = posterUrl;
          let arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          let blob = new Blob([u8arr], { type: mime });
          blob.lastModifiedDate = new Date();
          blob.name = "video_cut_" + new Date().valueOf();

          //console.log("blob", blob);
          let file = new window.File([blob], blob.name, { type: blob.type });
          //console.log("file", file)
          uploadFile(file, blob.name)
            .then((res) => {
              if (type == "first") {
                this.firstSnapLoading = false;
              } else {
                this.coverCutLoading = false;
              }
              console.log("cos upload res", res);
              if (res.status === "success") {
                if (type == "first") {
                  this.item.firstSnap = res.response.url;
                } else {
                  this.coverImags.push(res.response.url);
                  if (this.coverImags.length == 1) {
                    this.item.image = res.response.url;
                  }
                }
              } else {
                Vue.swal("截取封面失败");
              }
            })
            .catch((e) => {
              console.log("cos upload err", res);
              Vue.swal("截取封面失败");
              if (type == "first") {
                this.firstSnapLoading = false;
              } else {
                this.coverCutLoading = false;
              }
            })
            .finally((res) => {});
        })
        .catch((error) => {
          this.warning("截取失败");
          if (type == "first") {
            this.firstSnapLoading = false;
          } else {
            this.coverCutLoading = false;
          }
          console.log(error);
        });
    },
    toPreview() {
      this.previewUrl = this.item.previewUrl + "&backend=true";
      this.drawer = true;
    },
    openLog() {
      this.show = true;
      this.resId = Number(this.index_id);
    },
    getRedPacketInfo() {
      content.redPacketInfo().then((resp) => {
        if (resp.data) {
          // leftAmount 单位为分。所以需要/100
          this.pointTotal = parseFloat(resp.data.leftAmount / 100).toFixed(2);
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code == "tab") {
        this.currentTabs = obj.tabs;
        let tabIds = [];
        obj.tabs.forEach(function(item) {
          tabIds.push(item.id);
        });
        this.item.tag = tabIds.toString();
      }
      if (obj.code === "examine") {
        //提交审核后刷新
        this.goBack();
      }
      if (obj.code === "handleExamine") {
        //取消审核后刷新
        if (!this.$route.query.id) {
          Vue.swal({
            icon: "success",
            title: "视频创建成功！",
            showConfirmButton: false,
            timer: 1000,
          });
          this.$router.push({
            name: "videoPublishDetail",
            query: { id: this.item.id },
          });
          let that = this;
          setTimeout(function() {
            that.reload();
          }, 100);
        }
      }
      if (obj.code === "shop") {
        this.currentShop = obj.item;
      }
      if (obj.code === "coupon") {
        this.currentArticle = obj.item;
      }
      // if (obj.code == "comment") {
      //   this.currentComments = this.currentComments.concat(obj.item);
      // }
      console.log(obj);
    },

    fetch() {
      this.pageLoading = true;
      var params = {
        id: this.index_id,
      };
      content.detail(params).then((resp) => {
        console.log("视频详情", resp);
        if (resp.code == 0) {
          this.videoUrlSize = util.getFileSize(resp.data.videoUrlSize || 0);
          this.transcodeUrlSize = util.getFileSize(
            resp.data.transcodeUrlSize || 0
          );
          resp.data.disabledType = true;
          if (resp.data.couponId) {
            resp.data.rewardType = "0";
            this.getConpons(resp.data.couponId);
          } else {
            if (resp.data.redPacket) {
              if (resp.data.redPacket.id) {
                // resp.data.disabledType = true
                resp.data.rewardType = "1";
                resp.data.redPacket.type = resp.data.redPacket.type.toString();
                resp.data.redPacket.totalAmount = parseFloat(
                  resp.data.redPacket.totalAmount / 100
                );
              }
            } else {
              resp.data.redPacket = {};
              // resp.data.redPacket.disabledType = true
            }
          }

          if (resp.data.shopId) {
            this.getShop(resp.data.shopId);
          }

          // this.item.createTime = this.item.createdAt
          //设置选择了那些
          if (resp.data.viewDisabled) {
            this.choiceOperable.push("viewDisabled");
          }
          if (resp.data.commentDisabled) {
            this.choiceOperable.push("commentDisabled");
          }
          if (resp.data.shareDisabled) {
            this.choiceOperable.push("shareDisabled");
          }
          if (resp.data.likeDisabled) {
            this.choiceOperable.push("likeDisabled");
          }
          //评论设置选择了那些
          if (resp.data.commentImageDisabled) {
            this.choiceCommentRests.push("commentImageDisabled");
          }
          if (resp.data.commentVideoDisabled) {
            this.choiceCommentRests.push("commentVideoDisabled");
          }
          if (resp.data.image) {
            this.coverImags.push(resp.data.image);
          }

          if (resp.data.shareImage) {
            this.shareImage = {
              url: resp.data.shareImage,
            };
          }

          if (resp.data.tagVOList) {
            // this.getTags(resp.data.tag); //获取标签列表再根据标签id反查标签数据
            let currentTabs = [];
            let itemTags = resp.data.tagVOList;
            // let itemTagsName = this.item.tagName.split(",");
            for (var i = 0; i < itemTags.length; i++) {
              currentTabs.push({
                id: itemTags[i].id,
                name: itemTags[i].name,
              });
            }
            this.currentTabs = currentTabs;
          }
          this.item = resp.data;
          if (!resp.data.time) {
            this.getVideoTime(resp.data.transcodeUrl || resp.data.videoUrl);
          }
          this.oldImage = resp.data.image;
          this.oldImageWidth = resp.data.imageWidth;
          this.oldImageHeight = resp.data.imageHeight;
          // if (this.item.comments) {
          //   this.currentComments = this.item.comments;
          // }
          this.pageLoading = false;
        }
        this.$refs.titleCheck.checkTitle(resp.data.title);
      });
    },
    getSaveData() {
      let params = JSON.parse(JSON.stringify(this.item));
      params.userId = JSON.parse(localStorage.chosedMedia).id;
      delete params.taskId;
      // delete params.transcodeUrl;
      // delete params.firstSnap;
      if (!params.title) {
        Vue.swal("请输入标题");
        return;
      }
      // if (!params.subTitle) {
      //   Vue.swal("请输入短标题");
      //   return;
      // }
      // if(!params.content){
      //   Vue.swal("请输入描述");
      //   return
      // }
      if (params.publishedAt) {
        params.publishedAt = params.publishedAt;
      } else {
        Vue.swal("请选择发布日期");
        return;
      }
      params.viewDisabled = "0";
      params.commentDisabled = "0";
      params.shareDisabled = "0";
      params.likeDisabled = "0";
      for (var i = 0; i < this.choiceOperable.length; i++) {
        let key = this.choiceOperable[i];
        if (key == "viewDisabled") {
          params.viewDisabled = "1";
        }
        if (key == "commentDisabled") {
          params.commentDisabled = "1";
        }
        if (key == "shareDisabled") {
          params.shareDisabled = "1";
        }
        if (key == "likeDisabled") {
          params.likeDisabled = "1";
        }
      }
      params.commentImageDisabled = "0";
      params.commentVideoDisabled = "0";
      for (var i = 0; i < this.choiceCommentRests.length; i++) {
        let key = this.choiceCommentRests[i];
        if (key == "commentImageDisabled") {
          params.commentImageDisabled = "1";
        }
        if (key == "commentVideoDisabled") {
          params.commentVideoDisabled = "1";
        }
      }
      // if(!params.tag){
      //   Vue.swal("请选择标签");
      //   return
      // }

      //删除奖励
      delete params.couponId;
      delete params.redPacket;
      // if (params.rewardType) {
      //   // params.rewardType = 0优惠券
      //   if (params.rewardType == "0") {
      //     params.couponId = this.currentArticle.id
      //       ? this.currentArticle.id
      //       : "";
      //     delete params.redPacket;
      //   }
      //   // params.rewardType = 1红包
      //   if (params.rewardType == "1") {
      //     if (!params.redPacket.type) {
      //       Vue.swal("请选择红包类型");
      //       return;
      //     }
      //     if (params.redPacket.total) {
      //       if (Math.floor(params.redPacket.total) != params.redPacket.total) {
      //         Vue.swal("红包份数只能输入整数");
      //         return;
      //       }
      //     } else {
      //       Vue.swal("请输入红包份数");
      //       return;
      //     }
      //     if (params.redPacket.totalAmount) {
      //       let totalAmount = Number(params.redPacket.totalAmount);
      //       let total = Number(params.redPacket.total);
      //       let pointTotal = Number(this.pointTotal);
      //       if (pointTotal < totalAmount) {
      //         Vue.swal("当前可用点数不足");
      //         return;
      //       }
      //       if (totalAmount < total * 0.3) {
      //         Vue.swal("每份红包点数不得小于0.3");
      //         return;
      //       }
      //       // 后台单位为分。此处*100
      //       params.redPacket.totalAmount = totalAmount * 100;
      //     } else {
      //       Vue.swal("请输入红包点数");
      //       return;
      //     }
      //     if (!/^[0-9]+.?[0-9]*$/.test(params.redPacket.time)) {
      //       Vue.swal("请输入正确的观看秒数");
      //       return;
      //     }
      //     delete params.couponId;
      //   }
      // } else {
      //   delete params.couponId;
      //   delete params.redPacket;
      // }
      params.operateViewNum = getOperateNum(params.operateViewNum, "view");
      if (typeof params.operateViewNum == "string") {
        this.warning(params.operateViewNum);
        return;
      }
      params.operateLikeNum = getOperateNum(params.operateLikeNum, "like");
      if (typeof params.operateLikeNum == "string") {
        this.warning(params.operateLikeNum);
        return;
      }
      if (!params.image) {
        Vue.swal("请选择封面图片");
        return;
      }
      //删除门店参数
      delete params.shopId;
      // params.shopId = this.currentShop.id ? this.currentShop.id : "";

      // 1. 编辑信息的时候，保存传参 modifyType=1
      // 2. 编辑详情的时候，保存传参 modifyType=2
      if (this.isModify) {
        params.modifyType = 1;
      } else {
        params.modifyType = 2;
      }
      // params.comments = this.currentComments; //选择的评论列表
      //防止中文图片保存后无法访问
      params.videoUrl = decodeURI(params.videoUrl);
      params.image = decodeURI(params.image);
      if (params.firstSnap) {
        params.firstSnap = decodeURI(params.firstSnap);
      }
      if (params.transcodeUrl) {
        params.transcodeUrl = decodeURI(params.transcodeUrl);
      }
      //分享图片
      if (this.shareImage) {
        params.shareImage = this.shareImage.url;
      } else {
        params.shareImage = "";
      }
      if (!this.uploadStatus) {
        this.warning("视频上传中，请稍后重试");
        return;
      }
      if (!params.time) {
        this.warning("正在获取视频时长，请稍后重试");
        return;
      }
      if (this.index_id) {
        delete params.viewNum;
        delete params.likeNum;
        if (this.oldImage == params.image) {
          params.imageHeight = this.oldImageHeight;
          params.imageWidth = this.oldImageWidth;
        } else {
          params.imageHeight = 0;
          params.imageWidth = 0;
        }
      }
      console.log("保存参数", params);
      return params;
    },
    async submitPreserve(callback) {
      let params = this.getSaveData();
      if (!params) {
        return;
      }
      //检查标题是否重复
      let check = await this.checkContentTitle(params);
      if (!check) {
        return;
      }
      if (this.index_id) {
        content.modify(params).then((resp) => {
          if (resp.code == 0) {
            this.addCache("video-edit", {
              id: params.id,
            });
            if (callback) {
              callback();
            } else {
              Vue.swal({
                icon: "success",
                title: "保存成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.goBack();
            }
          } else {
            Vue.swal(resp.msg);
          }
        });
      } else {
        content.create(params).then((resp) => {
          if (resp.code == 0) {
            this.addCache("video-edit", {
              id: resp.data.id,
            });
            if (callback) {
              this.item.id = resp.data.id;
              this.item.isLy = resp.data.isLy;
              callback();
            } else {
              Vue.swal({
                icon: "success",
                title: "创建成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.goBack();
            }
          } else {
            Vue.swal(resp.msg);
          }
        });
      }
    },

    submitReview() {
      let params = this.getSaveData();
      if (!params) {
        return;
      }
      let msg1 = this.index_id ? "保存" : "创建";
      let msg2 = this.verifyFlag == 1 ? "免审发布?" : "提交审核?";
      this.confirm(`确认${msg1}并${msg2}`, this.saveAndDeliver);
    },
    saveAndDeliver() {
      let that = this;
      that.submitPreserve(function() {
        // let user = JSON.parse(that.cookies.getCookie("user"));
        // console.log('用户',user)
        // 媒体号进入龙渊，商家进入天问审核 userType 0普通用户(app) 1媒体号(pgc) 2商家 3水军(运营用户)
        // if (user.userType == 1) {
        //   that.$refs.examine.showModel(that.item);
        // }
        // if (user.userType == 2) {
        // }
        let params = {
          ids: [],
        };
        params.ids.push(that.item.id);
        content.examine(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: that.verifyFlag == 1 ? "发布成功" : "提交成功",
              showConfirmButton: false,
              timer: 1000,
            });
            that.goBack();
          } else {
            Vue.swal(resp.msg);
          }
        });
      });
    },
    batchRevert(item) {
      let that = this;
      Swal.fire({
        title: "确定撤销审核?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {
            ids: [],
          };
          params.ids.push(that.item.id);
          content.revert(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "撤销成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              that.goBack();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    submitPublish() {
      let that = this;
      that.submitPreserve(function() {
        Swal.fire({
          title: "确定发布?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#f46a6a",
          cancelButtonColor: "#74788d",
          confirmButtonText: "发布",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.value) {
            let params = {
              ids: [],
            };
            params.ids.push(that.item.id);
            content.publish(params).then((resp) => {
              if (resp.code == 0) {
                Vue.swal({
                  icon: "success",
                  title: "发布成功！",
                  showConfirmButton: false,
                  timer: 1000,
                });
                that.goBack();
              } else {
                Vue.swal(resp.msg);
              }
            });
          }
        });
      }, true);
    },

    //获取标签列表
    getTags(dataTags) {
      let params = {
        page: 1,
        pageSize: 999,
        type: 0, // 0内容标签  1用户标签
      };
      let itemTags = dataTags.split(",");
      tags.list(params).then((resp) => {
        if (resp.data) {
          if (resp.data.items) {
            let currentTabs = [];
            for (var i = 0; i < itemTags.length; i++) {
              for (var j = 0; j < resp.data.items.length; j++) {
                let item = resp.data.items[j];
                if (itemTags[i] == resp.data.items[j].id) {
                  currentTabs.push(resp.data.items[j]);
                }
              }
            }
            this.currentTabs = currentTabs;
          }
        }
      });
    },

    removeTabs(item) {
      this.currentTabs.splice(this.currentTabs.indexOf(item), 1);
    },
    // removeComment() {
    //   let that = this;
    //   this.selectCurrentItems.forEach(function(item) {
    //     that.currentComments.splice(that.currentComments.indexOf(item), 1);
    //   });
    //   this.selectCurrentItems = [];
    // },

    selectTag() {
      this.$refs.tag.showModel(this.currentTabs);
    },
    // selectComment() {
    //   this.$refs.comment.showModel();
    // },

    selectCoupon() {
      this.$refs.coupon.showModel();
    },

    selectShop() {
      this.$refs.shop.showModel();
    },

    uploadSuccess(file) {
      if (file.data) {
        this.coverImags.unshift(file.data);
        this.item.image = file.data;
      }
    },

    uploadVideoSuccess(file) {
      let url = "";
      console.log("file", file);
      if (file.data) {
        this.item.videoUrl = file.data;
        if (file.duration) {
          this.item.time = file.duration;
        } else {
          this.getVideoTime(file.transcodeUrl || file.data);
        }
        //如果原来没有封面就设为封面，如果原来有封面就展示出来让用户选择
        if (file.cover) {
          url = decodeURI(file.cover);
          this.coverImags.push(url);
          if (this.coverImags.length == 1) {
            this.item.image = url;
          }
          console.log("设置首帧", url);
          this.item.firstSnap = url;
        }
        if (file.transcodeUrl) {
          this.item.transcodeUrl = decodeURI(file.transcodeUrl);
        } else {
          this.item.transcodeUrl = "";
        }
        if (file.taskId) {
          this.item.taskId = file.taskId;
        }
      }
    },

    removeCover(index) {
      if (!this.isModify) {
        this.coverImags.splice(index, 1);
      }
    },

    deleteCoupon() {
      this.currentArticle = {};
    },

    deleteShop() {
      this.currentShop = {};
    },

    getCovers() {
      this.getCoverLoading = true;
      let params = {
        videoUrl: this.item.videoUrl,
      };
      auth.covers(params).then((resp) => {
        if (resp.code === 0 && resp.data) {
          if (resp.data.images) {
            this.setCovers(resp.data.images);
          }
        } else {
          this.warning("获取失败,请稍后重试");
          this.getCoverLoading = false;
        }
      });
    },
    //尝试加载获取的封面，每一秒尝试一次，最多半分钟
    async setCovers(arr) {
      for (let a = 0; a < 15; a++) {
        let result = await checkImageLink(arr[0]);
        console.log("检查结果", result);
        if (result) {
          this.getCoverLoading = false;
          console.log("");
          if (!this.item.image) {
            this.item.image = arr[0];
          }
          this.coverImags = this.coverImags.concat(arr);
          break;
        } else {
          await waitTime(2000);
        }
      }
    },

    getConpons(ids) {
      let params = {
        page: 1,
        pageSize: 99,
        "q%5Bids%5D": ids,
      };
      let that = this;
      coupon.list(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data.items.length) {
            that.currentArticle = resp.data.items[0];
          }
        }
      });
    },

    getShop(shopId) {
      let params = {
        id: shopId,
      };
      shop.detail(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data) {
            this.currentShop = resp.data;
          }
        }
      });
    },

    goBack() {
      contentAPI
        .lock({
          id: this.index_id,
          isLock: 0,
        })
        .then((res) => {});
      this.$router.go(-1);
      // this.$router.push({
      //   name: "videoPublish",
      // });
    },

    choseFile() {
      this.upload_file = document.getElementById("upload_file");
      this.upload_file.click();
    },
    upload(e) {
      console.log(e);
      let files = e.target.files;
      let type = files[0].type;
      if (type.indexOf("video") == -1) {
        this.info("文件类型选择错误");
        this.$refs.upload_file.value = "";
      }
      this.videoLoading = true;
      uploadFile(files[0], "videoUpload").then((res) => {
        if (res.status == "fail") {
          this.warning("上传失败");
          this.videoLoading = false;
          this.$refs.upload_file.value = "";
          return;
        } else if (res.status == "success") {
          this.$message.success("上传成功");
          this.$refs.upload_file.value = "";
          this.item.videoUrl = res.response.url;
          this.videoLoading = false;
        }
      });
    },
    changeCover(url) {
      this.item.image = url;
    },
    getVideoTime(url) {
      this.item.time = 0;
      getVideoDuration(url, (data) => {
        // console.log("接受到的时长", data);
        this.item.time = data;
      });
    },
    uploadChange(data) {
      console.log("上传状态改变", data);
      if (data == "begin") {
        this.uploadStatus = false;
      } else if (data == "end") {
        this.uploadStatus = true;
      }
    },
    //创建提交审核取消时页面变成编辑详情页面
    toDetail() {
      if (!this.$route.query.id) {
        this.coverImags = [];
        this.index_id = this.item.id;
        this.fetch();
        this.$router.replace({
          path: this.$route.path,
          query: {
            id: this.item.id,
          },
        });
      }
    },
    //没有视频或视频不是cos里的则禁用获取智能封面
    showGetCover() {
      if (this.item.videoUrl.indexOf("/saas/video") == -1) {
        return true;
      } else {
        return false;
      }
    },
    //检查标题是否重复
    async checkContentTitle(item) {
      let check = await checkRepeatTitle(item);
      console.log("检查结果", check);
      if (!check) {
        return false;
      } else {
        return true;
      }
    },
    checkTitle(str) {
      if (this.$refs.titleCheck) {
        this.$refs.titleCheck.checkTitle(str, !this.item.id);
      }
    },
    // 获取后缀
    showExt(filename) {
      const filenameArr = filename.split(".");
      if (filenameArr) {
        return filenameArr[filenameArr.length - 1];
      } else {
        return "";
      }
    },
    // 显示视频文件后缀
    showVideoExt(url) {
      return this.showExt(getFileName(url, false).name);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.video_wrap {
  .iframe_wrap {
    height: 100%;
  }
}
.liveCilStyle {
  cursor: auto;
  position: absolute;
  right: 0px;
  top: 0;
  z-index: 1000;
  color: #fff;
  padding: 6px 6px;
  border-radius: 4px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0,
    rgba(0, 0, 0, 0.65) 100%
  );
}
.iframe-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.submit-bar {
  /* border-top: 0;*/
  margin-top: 0px;
  border-top: 0px solid #ced4da;
  margin-bottom: 1.25rem;
}
.box_wrap {
  /* height: 700px; */
  overflow: auto;
}
.operate-input-item span {
  padding-right: 5px;
}

.operate-input-item input {
  width: calc(100% - 70px);
  margin-top: -0.55rem;
}

.cover-images .cover-img-item {
  display: flex;
  float: left;
}

.cover-images .cover-img-item .cover-delete {
  font-size: 16px;
  padding-left: 10px;
  cursor: pointer;
}

.cover-images .cover-img-item .cover-image-main {
  /*width: 130px;*/
  text-align: center;
}

.cover-images .cover-img-item .cover-image-main img {
  /*width: 100%;*/
  height: 162px;
  border-radius: 6px;
  display: block;
}

.cover-images .cover-img-item .cover-image-main i {
  padding-top: 10px;
  font-size: 30px;
  cursor: pointer;
}

.select-current-media {
  display: inline-block;
  width: auto;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  position: relative;
  padding-left: 3.2rem;
}

.select-current-media img {
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  left: 0.75rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.video-url-bg {
  position: relative;
  border: 1px solid #ced4da;
  width: 600px;
  background-image: url(../../../assets/images/image-null.jpg);
  background-size: 100% 100%;
}

.video-url-bg video {
  width: 100%;
  display: block;
}
</style>
